import * as React from 'react';
import moment from 'moment';
import { Table } from 'semantic-grab-ui/src';

const showStartTimeAndEndTime = (frequency: string, viewType: "review" | "preview") => {
  if (viewType === 'review') { return true; }
  if (frequency === 'nr') { return false; }
  return true;
};

const isNextTriggerTimeIsPast = (nextTriggerDate: Date) => {
  if (!nextTriggerDate) {
    return true;
  }
  const nextDate = new Date(nextTriggerDate);
  const currDate = new Date();
  if (currDate >= nextDate) { return true; }
  return false;
};

const getNextTriggerTime = (nextTriggerDate: Date) => {
  if (isNextTriggerTimeIsPast(nextTriggerDate)) {
    return (<Table.Row textAlign="center">
      <Table.Cell colSpan={2}>
        <span>No More Next Trigger</span>
      </Table.Cell>
    </Table.Row>);
  }
  const formattedTime = moment(nextTriggerDate).format('DD-MM-YYYY hh:mm a');
  return (<Table.Row>
    <Table.Cell>
      <span>Next</span>
    </Table.Cell>
    <Table.Cell>
      <span>{formattedTime}</span>
    </Table.Cell>
  </Table.Row>);
};

const TimeShow = ({ startTime, endTime, lastHappenedAt, frequency, viewType, nextTriggerDate }: {startTime: string, endTime: string, lastHappenedAt: string, frequency: string, viewType: "review" | "preview", nextTriggerDate: Date}) => {
  return (
    <Table striped>
      <Table.Body>
        {
          showStartTimeAndEndTime(frequency, viewType) &&
          <React.Fragment>
            <Table.Row>
              <Table.Cell>
                <span>Start</span>
              </Table.Cell>
              <Table.Cell>
                <span>{startTime}</span>
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>
                <span>End</span>
              </Table.Cell>
              <Table.Cell>
                <span>{endTime}</span>
              </Table.Cell>
            </Table.Row>
          </React.Fragment>
        }
        {
          nextTriggerDate &&
          getNextTriggerTime(nextTriggerDate)
        }
        {
          lastHappenedAt && lastHappenedAt.length > 0 &&
          <Table.Row>
            <Table.Cell>
              <span>Last</span>
            </Table.Cell>
            <Table.Cell>
              <span>{lastHappenedAt}</span>
            </Table.Cell>
          </Table.Row>
        }
      </Table.Body>
    </Table>
  );
};

export default TimeShow;
